module.exports = __webpack_public_path__ + "static/media/ads.0931cfcc.png";